import { apiConfig } from 'config';
import { handle420 } from 'apis/HandleError';
import { fetchdata } from './FetchData';

export function postDevicesAggregate(body) {
  const auth = window.__APP_AUTH;
  const url = apiConfig.cmServiceDevicesAggregate;
  const headers = {
    Accept: '*application/json*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
    'Content-Type': 'application/json'
  };

  return fetchdata(url, { headers, method: 'POST', body: JSON.stringify(body) })
    .then((result) => {
      return result;
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
}
